import { useContext, useEffect, useState } from 'react';

import { Form } from '@zillow/constellation-10';

import { DISPLAY_SERVER_ERROR_AT } from '../../../constants/WizardConstants';

import { ModularListingContext } from '../../../containers/CreateListingPage/context';
import { WizardContext } from '../../../components/Wizard/context';

import PageWizard from '../../../components/Wizard/PageWizard';
import WizardAlert from '../../../components/WizardAlert';

import FormSectionContainer from './components/FormSectionContainer';
import { WizardFlexContainer } from '../../../styles/wizard';

import type { FormEvent } from 'react';
import type { PageWizardProps } from '../../../components/Wizard/PageWizard';

type Props = {
  onGoToPrevStep: () => void;
  onGoToNextStep: () => void;
  onExitWizard: () => void;
  wizardTitle?: React.ReactNode;
  progressStepper?: React.ReactNode;
  totalSteps?: number;
  currentStepIndex?: number;
  showDesktopViewBreakpoint?: PageWizardProps['showDesktopViewBreakpoint'];
};

const RelistConfirmDetails = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}: Props) => {
  const {
    // @ts-expect-error
    wizardState: { isFetchingData },
  } = useContext(WizardContext);

  const {
    modularListingState: { serverErrorObj },
  } = useContext(ModularListingContext);

  const [clickedNext, setClickedNext] = useState(false);
  const [clickedBackNext, setClickedBack] = useState(false);

  useEffect(() => {
    const { fieldName } = serverErrorObj;

    if (!fieldName && !isFetchingData) {
      checkNavToStep();
    }
  }, [isFetchingData]);

  const checkNavToStep = () => {
    if (clickedNext) {
      onNextClick();
    }

    if (clickedBackNext) {
      onBackClick();
    }
  };

  const onNextClick = () => {
    if (isFetchingData) {
      setClickedNext(true);
      return;
    }

    onGoToNextStep();
  };

  const onBackClick = () => {
    if (isFetchingData) {
      setClickedBack(true);
      return;
    }

    onGoToPrevStep();
  };

  return (
    <PageWizard
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onNextClick}
      onBackClick={onBackClick}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
      hideBackButton={true}
      {...rest}
    >
      <div data-testid="RelistConfirmDetails">
        <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.PAGE} />

        <WizardFlexContainer>
          {/* cast as div to prevent cannot appear as a descendant of form error */}
          <Form asChild={true} onSubmit={(e: FormEvent<HTMLFormElement>) => e.preventDefault()}>
            <div>
              <FormSectionContainer />
            </div>
          </Form>
        </WizardFlexContainer>
      </div>
    </PageWizard>
  );
};

export default RelistConfirmDetails;
